
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

export default function RequireAdmin({ children }) {
  const { booted, user, role } = useAuth();
  const location = useLocation();

  if (!booted) return null;
  if (!user) return <Navigate to="/" state={{ from: location }} replace />;

  const allowed = role === 'admin' || role === 'owner' || role === 'developer';
  if (!allowed) return <Navigate to="/" replace />;

  return children;
}
